webpackJsonp([35783957827783],{

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FrontDescription = function FrontDescription() {
	  return _react2.default.createElement(
	    "section",
	    { className: "front-description" },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-lg-5" },
	          _react2.default.createElement(
	            "div",
	            { className: "front-description__title" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "ETL Filter, Raitz & Kollegen Steuerberatungsgesellschaft"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "front-description__text col-lg-6" },
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "Kompetent, motiviert, flexibel, zuverl\xE4ssig."
	            )
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Wir betreuen mit zwei Steuerberatern, zwei Wirtschaftspr\xFCferinnen / Steuerberaterinnen und einem Team von hochqualifizierten Mitarbeitern im ganzen Bundesgebiet mittelst\xE4ndische Unternehmen aus allen Branchen und Rechtsformen, sowie Privatpersonen."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Die Kombination aus erfahrenen und jungen Berufskollegen mit unterschiedlichen Ausbildungsschwerpunkten (Universit\xE4t, Finanzverwaltung) geh\xF6rt zu unseren St\xE4rken."
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = FrontDescription;
	module.exports = exports["default"];

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _group_of_people = __webpack_require__(57);
	
	var _group_of_people2 = _interopRequireDefault(_group_of_people);
	
	var _three_people = __webpack_require__(59);
	
	var _three_people2 = _interopRequireDefault(_three_people);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PreFooter = function PreFooter() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'pre-footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'pre-footer__column col-sm-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pre-footer__box' },
	            _react2.default.createElement('i', { className: 'c-icon c-icon--check_circle' }),
	            _react2.default.createElement(
	              'h3',
	              { className: 'pre-footer__text' },
	              'seit ',
	              _react2.default.createElement('br', null),
	              ' 1950'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pre-footer__column col-sm-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pre-footer__box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pre-footer__custom-icon' },
	              _react2.default.createElement('img', { className: 'pre-footer__custom-icon__image', src: _three_people2.default, alt: 'Partner Ikon' })
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'pre-footer__text' },
	              '4 ',
	              _react2.default.createElement('br', null),
	              ' Partner'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pre-footer__column col-sm-4' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pre-footer__box' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pre-footer__custom-icon' },
	              _react2.default.createElement('img', { className: 'pre-footer__custom-icon__image', src: _group_of_people2.default, alt: 'Group Ikon' })
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: 'pre-footer__text' },
	              '20+ ',
	              _react2.default.createElement('br', null),
	              ' Mitarbeiter'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = PreFooter;
	module.exports = exports['default'];

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMzNzNmNDU7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5ncm91cF9vZl9wZW9wbGU8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PGcgaWQ9InN1cmZhY2UxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xOCwxMGE1LDUsMCwxLDAtNS01QTUsNSwwLDAsMCwxOCwxMFptMTAsNmE1LDUsMCwxLDAtNS01QTUsNSwwLDAsMCwyOCwxNlpNOCwxNmE1LDUsMCwxLDAtNS01QTUsNSwwLDAsMCw4LDE2Wm01LDBhNSw1LDAsMSwwLDUtNUE1LDUsMCwwLDAsMTMsMTZabTUsNmMtNC4yNiwwLTgsMi40My04LDUuMlYzMEgyNlYyNy4yQzI2LDI0LjQzLDIyLjI2LDIyLDE4LDIyWm0tNC45Mi0xYTcsNywwLDAsMS0xLjkyLTMuNDlMMTEsMTcuNDJBMTEuODIsMTEuODIsMCwwLDAsOCwxN2MtNC4yNiwwLTgsMi40My04LDUuMlYyNUg4LjUyQTguNTIsOC41MiwwLDAsMSwxMy4wOCwyMVpNMzYsMjIuMmMwLTIuNzItMy44MS01LjItOC01LjJhMTEuMzIsMTEuMzIsMCwwLDAtMywuNDFsLS4xMS4wNUE3LDcsMCwwLDEsMjIuOTIsMjFhOC41Miw4LjUyLDAsMCwxLDQuNTYsNEgzNloiLz48L2c+PC9nPjwvZz48L3N2Zz4="

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/shutterstock_653993329.14b4d28e.jpg";

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8cGF0aCBkPSJNIDEyIDQgQSAzLjUgMy41IDAgMCAwIDguNSA3LjUgQSAzLjUgMy41IDAgMCAwIDEyIDExIEEgMy41IDMuNSAwIDAgMCAxNS41IDcuNSBBIDMuNSAzLjUgMCAwIDAgMTIgNCB6IE0gNC41IDcgQSAyLjUgMi41IDAgMCAwIDIgOS41IEEgMi41IDIuNSAwIDAgMCA0LjUgMTIgQSAyLjUgMi41IDAgMCAwIDcgOS41IEEgMi41IDIuNSAwIDAgMCA0LjUgNyB6IE0gMTkuNSA3IEEgMi41IDIuNSAwIDAgMCAxNyA5LjUgQSAyLjUgMi41IDAgMCAwIDE5LjUgMTIgQSAyLjUgMi41IDAgMCAwIDIyIDkuNSBBIDIuNSAyLjUgMCAwIDAgMTkuNSA3IHogTSAxMiAxMyBDIDkuNjY0IDEzIDUgMTQuMTczIDUgMTYuNSBMIDUgMjAgTCAxOSAyMCBMIDE5IDE2LjUgQyAxOSAxNC4xNzMgMTQuMzM2IDEzIDEyIDEzIHogTSAzLjg5ODQzNzUgMTQuMDUyNzM0IEMgMi4zMTc0Mzc1IDE0LjI5NjczNCAwIDE1LjM4OTA3OCAwIDE2LjcwNTA3OCBMIDAgMjAgTCAzIDIwIEwgMyAxNi41IEMgMyAxNS41MzkgMy4zNDU0Mzc1IDE0LjczMjczNCAzLjg5ODQzNzUgMTQuMDUyNzM0IHogTSAyMC4xMDE1NjIgMTQuMDUyNzM0IEMgMjAuNjU0NTYzIDE0LjczMjczNCAyMSAxNS41MzkgMjEgMTYuNSBMIDIxIDIwIEwgMjQgMjAgTCAyNCAxNi43MDUwNzggQyAyNCAxNS4zODkwNzggMjEuNjgyNTYyIDE0LjI5NjczNCAyMC4xMDE1NjIgMTQuMDUyNzM0IHoiIHN0cm9rZT0ibm9uZSIgZmlsbD0iIzM3M2Y0NSIgc3Ryb2tlLXdpZHRoPSIxcHgiPjwvcGF0aD4KPC9zdmc+Cg=="

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _banner = __webpack_require__(22);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _frontDescription = __webpack_require__(240);
	
	var _frontDescription2 = _interopRequireDefault(_frontDescription);
	
	var _services = __webpack_require__(27);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _preFooter = __webpack_require__(47);
	
	var _preFooter2 = _interopRequireDefault(_preFooter);
	
	var _shutterstock_ = __webpack_require__(631);
	
	var _shutterstock_2 = _interopRequireDefault(_shutterstock_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_banner2.default, {
	      title: 'Ihr kompetenter Partner in Sachen Steuerberatung, Wirtschaftspr\xFCfung, k\u200Caufm\xE4nnische Dienstleistungen.',
	      image: _shutterstock_2.default,
	      rightAligned: true
	    }),
	    _react2.default.createElement(_frontDescription2.default, null),
	    _react2.default.createElement(_services2.default, {
	      taxAdvice: true,
	      businessAdvice: true,
	      servicesInCooperation: true,
	      accounting: true,
	      businessValuation: true
	    }),
	    _react2.default.createElement(_preFooter2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a87d951d531151d9f94b.js